import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';

import * as Actions from '../../../redux/actions';
import SensorModuleDetail from './SensorModuleDetail';


class SensorModuleDetailContainer extends Component {
  handleError(mode, error) {
    const { dispatch, stackId } = this.props;
    dispatch(Actions.Detail.reportError(error, stackId));
  }

  handleApply(mode, applyData) {
    if (mode === 'edit') {
      this.handleApplyEdit(applyData);
    } else if (mode === 'create') {
      this.handleApplyCreate(applyData);
    }
  }

  handleApplyEdit(applyData) {
    const {
      dispatch,
      sensor,
      orgId,
      stackId,
      parentStackId,
    } = this.props;

    switch (applyData.action) {
      case 'remove':
        dispatch(Actions.Detail.deleteSensorModule(orgId, sensor.id, applyData.module_uuid, stackId, parentStackId));
        break;
      case 'update_meta':
      case 'upgrade':
      case 'rotate_secrets':
        dispatch(Actions.Detail.updateSensorModule(orgId, sensor.id, applyData.module_uuid, applyData.data, stackId, parentStackId));
        break;
      default:
        console.warn('Unrecognized apply action', applyData.action);
        break;
    }
  }

  handleApplyCreate(applyData) {
    const {
      dispatch,
      sensor,
      orgId,
      stackId,
      parentStackId,
    } = this.props;

    dispatch(Actions.Detail.createSensorModule(orgId, sensor.id, applyData, stackId, parentStackId));
  }

  render() {
    const {
      sensor = {},
      module = null,
      orgId,
      handleClose,
    } = this.props;

    const mode = _.isNil(module) || _.isEmpty(module) ? 'create' : 'edit';

    return (
      <SensorModuleDetail
        orgId={orgId}
        sensor={sensor}
        module={module}
        mode={mode}
        handleCancel={handleClose}
        handleApply={saveData => this.handleApply(mode, saveData)}
        handleError={error => this.handleError(mode, error)}
      />);
  }
}

SensorModuleDetailContainer.propTypes = {
  dispatch: PropTypes.func.isRequired,
  stackId: PropTypes.string.isRequired,
  parentStackId: PropTypes.string,
  orgId: PropTypes.string.isRequired,
  sensor: PropTypes.shape({}).isRequired,
  module: PropTypes.shape({}),
  handleClose: PropTypes.func,
};

SensorModuleDetailContainer.defaultProps = {
  parentStackId: null,
  module: {},
  handleClose: () => {},
};

const mapStateToProps = state => ({}); // eslint-disable-line no-unused-vars

const mapDispatchToProps = dispatch => ({ dispatch });

export default connect(mapStateToProps, mapDispatchToProps)(SensorModuleDetailContainer);



// WEBPACK FOOTER //
// ./src/views/Components/Detail/SensorModuleDetailContainer.js